import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import VGS from "./assets/vgs.png";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  layout: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100vh",
    padding: theme.spacing(10, 2, 3),
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      padding: theme.spacing(10, 3, 3),
    },
    "@supports (min-height: 100dvh)": {
      minHeight: "100dvh",
    },
  },
  paper: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 640,
    padding: theme.spacing(4, 3),
    textAlign: "center",
  },
  logo: {
    display: "block",
    width: 100,
    height: 100,
    objectFit: "contain",
    margin: `0 auto ${theme.spacing(2)}px`,
  },
}));

export default function AcercaDe() {
  const classes = useStyles();

  return (
    <main className={classes.layout}>
      <Paper className={classes.paper} elevation={2}>
        <img src={VGS} alt="Logotipo de VGS" className={classes.logo} />
        <Typography component="h1" variant="h4" gutterBottom>
          Sobre APATAXI Lleida
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Associació Provincial d'Auto Taxis de Lleida
        </Typography>
      </Paper>
    </main>
  );
}
